module.exports = __webpack_public_path__ + "static/polityka-prywatnosci-4a9e754475328b479f30a784c19a397c.pdf";